module.exports = __webpack_public_path__ + "img/searchNotFound.7991f7fd.svg";